import { render, staticRenderFns } from "./InstructorCard.vue?vue&type=template&id=2868b434&"
import script from "./InstructorCard.vue?vue&type=script&lang=js&"
export * from "./InstructorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports